import { IStudyChild } from '../entity';
import { schema } from 'normalizr';
import {
  AnnotationsKey,
  entityKey,
} from '@core/state/entities/entity-name-map';
import {AnnotationDto} from '@core/services/api-client.generated';

// export interface QuestionGroup<K extends keyof AnswerTypes> {
//     answers: IAnswerGroup[];
//     type: K;
// }

// export interface IAnswerGroup {
//     answer: PrimitiveAnswerTypes;
//     notes: string;
//     subquestions: QuestionMap;
//     annotationId: string;
// }

export interface IAnnotationMap {
  [id: string]: IAnnotation;
}

export interface IAnnotatorAnnotations {
  annotatorId: string;
  annotations: IAnnotation[];
}

export type PrimitiveAnswerTypes =
  | string
  | boolean
  | number
  | string[]
  | number[];

export interface AnswerTypes {
  string: string;
  boolean: string;
  integer: string;
  decimal: string;
  stringArray: string;
  integerArray: string;
  decimalArray: string;
}

export const answerType: AnswerTypes = {
  string: 'string',
  boolean: 'boolean',
  integer: 'integer',
  decimal: 'decimal',
  stringArray: 'stringArray',
  integerArray: 'integerArray',
  decimalArray: 'decimalArray',
};

export enum AnswerType {
  string = 'string',
  boolean = 'boolean',
  integer = 'integer',
  decimal = 'decimal',
  stringArray = 'stringArray',
  integerArray = 'integerArray',
  decimalArray = 'decimalArray',
}

export const arrayAnswerTypes = {
  string: 'stringArray',
  integer: 'integerArray',
  decimal: 'decimalArray',
};

export enum FormError {
  nonInteger = 'nonInteger',
  nonDecimal = 'nonDecimal',
  required = 'required',
}

// export interface QuestionMap {
//     [questionId: string]: QuestionGroup<keyof AnswerTypes>;
// };

export interface IAnnotation extends IStudyChild,AnnotationDto {
  studyId: string;
  annotatorId: string;
  questionId: string;
  question: string;
  answerType: keyof AnswerTypes;
  projectId: string;
  notes: string;
  parentId: string | null;
  children: string[];
  root: boolean;
  answer: PrimitiveAnswerTypes;
  stageId: string;
  reconciled: boolean;
}

export type AnnotationEntityKeys = AnnotationsKey;
export const annotationSchema = new schema.Entity(entityKey.annotations, {});
